export const ANALYTICS_EVENTS = {
  // Retention-relevant
  APP_OPENED: 'app_opened',

  // Engagement (for future funnels)
  TASK_CREATED: 'task_created',
  TASK_COMPLETED: 'task_completed',
  GOAL_CREATED: 'goal_created',
  TAB_OPENED: 'tab_opened',

  // Sync health
  SYNC_ERROR: 'sync_error',
} as const
